module.exports = __webpack_public_path__ + "static/media/student29.67656bab.png";